// extracted by mini-css-extract-plugin
export default {"user-avatar":"_25Qg3","userAvatar":"_25Qg3","pixelated":"H3qwA"};